export default __webpack_public_path__ + "static/kerutwajah-eb53425f56a322c72dfa41c6fb205a71.png";